module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-发布成功.e7cf7.png";